import { SHOW_LOW_CALL_VOLUME_REMINDER, DISMISS_LOW_CALL_VOLUME_REMINDER } from '../../actions/actionTypes/lowCallVolumeReminder';

export interface LowCallVolumeReminderState {
    // Whether the full-screen "low call volume" reminder is currently shown.
    alertVisible: boolean;
    // Number of recorded calls counted in the last window (shown in the reminder).
    callCount: number;
    // The configured window length in hours (shown in the reminder copy).
    periodHours: number;
}

export const initialState: LowCallVolumeReminderState = {
    alertVisible: false,
    callCount: 0,
    periodHours: 2
};

interface ReducerAction {
    type: string;
    payload?: { callCount?: number; periodHours?: number };
}

// The reminder logic (login-anchored checks, call counting, persistence) lives
// in the LowCallVolumeReminder middleware. This reducer only holds the UI state
// the view layer renders. It is transient (not persisted).
const lowCallVolumeReminderReducer = (state: LowCallVolumeReminderState | undefined, action: ReducerAction): LowCallVolumeReminderState => {
    const currentState = state ?? initialState;

    switch (action.type) {
        case SHOW_LOW_CALL_VOLUME_REMINDER:
            return {
                ...currentState,
                alertVisible: true,
                callCount: action.payload?.callCount ?? 0,
                periodHours: action.payload?.periodHours ?? currentState.periodHours
            };

        case DISMISS_LOW_CALL_VOLUME_REMINDER:
            return { ...currentState, alertVisible: false };

        default:
            return currentState;
    }
};

export default lowCallVolumeReminderReducer;
